import { useState } from "react";
import { NavLink } from "react-router-dom";
import { navLinks, siteInfo } from "@/mocks/site";
import SearchOverlay from "@/components/feature/SearchOverlay";

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);

  return (
    <>
      <header className="sticky top-0 z-[60] w-full border-b border-background-200 bg-background-50/90 backdrop-blur">
        <div className="flex h-16 w-full items-center gap-4 px-4 md:h-[72px] md:px-8">
          <NavLink to="/" className="mr-2 flex shrink-0 items-center gap-2 md:mr-6" onClick={() => setMobileOpen(false)}>
            <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50 md:h-10 md:w-10">
              <i className="ri-emotion-happy-line text-xl"></i>
            </span>
            <span className="leading-tight">
              <span className="block font-heading text-lg font-bold tracking-tight text-foreground-950 md:text-xl">
                {siteInfo.name}
              </span>
              <span className="hidden text-[11px] text-foreground-500 md:block">{siteInfo.slogan}</span>
            </span>
          </NavLink>

          <nav aria-label="主导航" className="hidden flex-1 items-center gap-1 lg:flex">
            {navLinks.map((link) => (
              <NavLink
                key={link.to}
                to={link.to}
                end={link.to === "/"}
                className={({ isActive }) =>
                  `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
                    isActive
                      ? "bg-primary-100 font-medium text-primary-700"
                      : "text-foreground-600 hover:bg-background-100 hover:text-foreground-950"
                  }`
                }
              >
                {link.label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-2">
            <button
              type="button"
              onClick={() => setSearchOpen(true)}
              className="flex h-10 cursor-pointer items-center gap-2 rounded-md border border-background-200 bg-background-50 px-3 text-sm text-foreground-500 hover:border-primary-300 hover:text-primary-700"
              aria-label="搜索站内内容"
            >
              <i className="ri-search-line text-base"></i>
              <span className="hidden md:inline">搜索</span>
            </button>
            <NavLink
              to="/about"
              className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
            >
              关于瓜乐圈
            </NavLink>
            <button
              type="button"
              onClick={() => setMobileOpen((value) => !value)}
              className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-700 lg:hidden"
              aria-label="打开导航菜单"
              aria-expanded={mobileOpen}
            >
              <i className={mobileOpen ? "ri-close-line text-xl" : "ri-menu-2-line text-xl"}></i>
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div className="border-t border-background-200 bg-background-50 lg:hidden">
            <nav aria-label="移动端导航" className="flex flex-col px-4 py-3">
              {navLinks.map((link) => (
                <NavLink
                  key={link.to}
                  to={link.to}
                  end={link.to === "/"}
                  onClick={() => setMobileOpen(false)}
                  className={({ isActive }) =>
                    `whitespace-nowrap rounded-md px-3 py-3 text-sm ${
                      isActive
                        ? "bg-primary-100 font-medium text-primary-700"
                        : "text-foreground-700 hover:bg-background-100"
                    }`
                  }
                >
                  {link.label}
                </NavLink>
              ))}
            </nav>
          </div>
        )}
      </header>

      <SearchOverlay open={searchOpen} onClose={() => setSearchOpen(false)} />
    </>
  );
}